// Efek suara sederhana dengan Web Audio (baru berbunyi setelah ada sentuhan pengguna).
import { S } from './state.js';
let AC = null;
function tone(freqs, dur, type = 'triangle') {
  if (!S.sound) return;
  try {
    AC = AC || new (window.AudioContext || window.webkitAudioContext)();
    const t0 = AC.currentTime;
    freqs.forEach((f, i) => {
      const o = AC.createOscillator(), g = AC.createGain();
      o.type = type; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t0 + i * dur);
      g.gain.exponentialRampToValueAtTime(0.18, t0 + i * dur + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + (i + 1) * dur);
      o.connect(g).connect(AC.destination);
      o.start(t0 + i * dur); o.stop(t0 + (i + 1) * dur + 0.05);
    });
  } catch (e) { /* perangkat tanpa audio */ }
}
export const sfx = {
  ok: () => tone([660, 880, 1175], 0.11),
  no: () => tone([330, 247], 0.17, 'sine'),
  win: () => tone([523, 659, 784, 1047, 1319], 0.13),
  tap: () => tone([520], 0.05),
};
